// extracted by mini-css-extract-plugin
var _1 = "TaskTypesFieldEmpty-moduleTaskTypesFieldEmpty__Or4qJ TaskTypesField-moduleTaskTypesField__OniHG";
export { _1 as "TaskTypesFieldEmpty" }
